<template>
  <section
    v-if="mainContent"
    class="section-bg-home h-screen px-4"
    :style="{ backgroundImage: `url(${bgImage})` }"
  >
    <div class="title">
      <div>
        <h1 class="text-2xl sm:text-4xl md:text-5xl lg:text-7xl">
          {{ mainContent.main_title }}
        </h1>
        <p class="text-main-300 text-lg sm:text-2xl md:text-3xl lg:text-5xl">
          {{ mainContent.main_subtitle }}
        </p>
      </div>

      <hr class="separator" />

      <div class="mt-2 sm:text-lg md:text-xl">
        <p>
          <span v-if="mainContent.calendar_icon" class="pr-3">
            <BaseIcon :name="['far', 'calendar-alt']" />
          </span>
          {{ mainContent.main_small_text }}
        </p>
      </div>

      <div v-if="!userIsAuthenticated" class="mt-24">
        <p>Si estás registrado, Accede. Si no estás registrado, Regístrate</p>
        <div class="flex justify-center pt-8">
          <BaseButton class="mx-2" :to="{ name: 'Login' }">
            Accede
          </BaseButton>
          <BaseButton class="mx-2" :to="{ name: 'Register' }">
            <img
              height="1"
              width="1"
              style="display:none;"
              alt=""
              src="https://px.ads.linkedin.com/collect/?pid=2457690&conversionId=3033554&fmt=gif"
            />
            Regístrate
          </BaseButton>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapState('home', ['mainContent']),
    ...mapGetters('auth', ['userIsAuthenticated']),

    bgImage() {
      if (this.mainContent.bg_image_url) {
        return this.mainContent.bg_image_url
      }

      return '/img/home-background.jpg'
    },
  },
}
</script>

<style scoped>
.separator {
  @apply w-12 mx-auto mt-4 mb-6;
  border-top: none;
  background-color: #ffa304;
  height: 3px;
}

.title {
  @apply p-8;

  background: rgba(0, 0, 0, 0.5);
}
</style>
